export default "__VITE_ASSET__Cr85QrHW__"